import { c as _c } from "react/compiler-runtime";
import { useState, useEffect } from 'react';
function useDebounce(value, delay) {
  const $ = _c(5);
  const [debouncedValue, setDebouncedValue] = useState(value);
  let t0;
  if ($[0] !== delay || $[1] !== value) {
    t0 = () => {
      const handler = setTimeout(() => {
        setDebouncedValue(value);
      }, delay);
      return () => {
        clearTimeout(handler);
      };
    };
    $[0] = delay;
    $[1] = value;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== value) {
    t1 = [value];
    $[3] = value;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  useEffect(t0, t1);
  return debouncedValue;
}
export default useDebounce;